import { useEffect, useState } from "react"
import { AccountEditor } from "../../../../../editor/AccountEditor"
import useDataBean from "../../../../../../core/services/dataBean/useDataBean"
import { _single, _UBLInvoice } from "../../../../../../core/services/dataBean/EntityCatalog"
import { FileInput } from "../../../../../theme/Component/FileInput"
import { BasicSwitch } from "../../../../../theme/Component/BasicSwitch"
import { InputDate } from "../../../../../theme/Input/InputDate"
import { BasicButton } from "../../../../../theme/Component/BasicButton"
import { PrintJson } from "../../../../../theme/Component/PrintJson"
import { BasicTable, MASK_BOOLEAN, MASK_DATE, MASK_MONEY, MASK_NUMBER } from "../../../../../theme/Component/BasicTable"
import { ListMenu } from "../../../../../theme/Component/ListMenu"
import { Modal } from "../../../../../theme/Component/Modal"
import { FileService } from "../../../../../../core/services/FileService"
import { HistoryUBLInvoice } from "../HistoryUBLInvoice"
import { CreateUBLInvoiceItems } from "./CreateUBLInvoiveItem"
import { FireElectronicDocument } from "../FireElectronicDocument/FireElectronicDocument"
import { AccountantDocumentList } from "../AccountantDocumentList/AccountantDocumentList"
import { SelectAccountantConceptCatalogForSalesInvoice } from "../SelectAccountantConceptCatalogForSalesInvoice"
import { SelectBusinessCore } from "../../../../../erp/cellEditor/BusinessCore/SelectBusinessCore"
import { SelectProject } from "../../../../../erp/cellEditor/BudgetAccountantOperation/SelectProject"
import { toast } from "react-toastify"
import { DocumentViewer } from "../../../../../theme/Component/DocumentViewer"
import { SelectStoreEditor } from "../SelectStore.editor"
import { InputMoney } from "../../../../../theme/Input/InputMoney"
import { PrepaidPaymentEditor } from "./ComponentPrepaidPayment/PrepaidPaymentEditor"
import { ReciablePaymentEditor } from "./ComponentPrepaidPayment/ReciablePaymentEditor"
import { UBLDocumentCatalogEditor } from "../../../../../contabilidad/CatalogoDocumentosUBL/UBLDocumentCatalogEditor"
import useModal, { MODAL_LG } from "../../../../../theme/Component/hooks/useModal"
import { EditorUBLDiscrepancyResponse } from "../../UBLDiscrepancyResponse/EditorUBLDiscrepancyResponse"

interface Props {
    _onChange2?: Function;
    _idAccount?: number;
    entry?: "Credit" | "Debit";
    initialInvoice?: any;
    embedded?: boolean;
    onSaved?: (invoice?: any) => void;
}

export interface DocumentPDF {
    MediaContext: string;
    Media: string;
    Filename: string;
    Type: string;
    URLLink: string | null;
}

export const CreateUBLInvoiceNote = ({ _onChange2, entry = "Credit", initialInvoice, embedded = false, onSaved }: Props) => {

    const { bean, setBean, lista, setLista, instance } = useDataBean(_UBLInvoice);
    const fileService = new FileService();

    const modifiAnyWay = _single.getSessionItem("canModifiUBL") ? JSON.parse(_single.getSessionItem("canModifiUBL")) : false;
    const noteLabel = entry === "Credit" ? "Nota Credito" : "Nota Debito";

    const [recordDate, setRecordDate] = useState<any>(_single.getCurrenDate());
    const [file, setFile] = useState<any>({});
    const [urlFile, setUrlFile] = useState<string | null>(null);
    const [donwloadURL, setDonwloadURL] = useState<string>(null);
    const [obs, setObs] = useState<string>(" ");
    const [fileType, setFileType] = useState<string>(null);
    const [document, setDocument] = useState<any>([]);
    const [documentError, setDocumentError] = useState<any>([]);

    const [modalB, setModalB] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: false, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-xl' });
    const [modalFire, setModalFire] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalSeeDoc, setModalSeeDoc] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalAccounting, setModalAccounting] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalVisor, setModalVisor] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalCustomer, setModalCustomer] = useState<any>({ tabIndex: -1, view: false, btnClose: false, btnSubmit: true, format: 'modal-md' });
    const [modalPrepaid, setModalPrepaid] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalApplyPrepaid, setModalApplyPrepaid] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const modalForm = useModal(`Crear ${noteLabel}`, MODAL_LG);

    useEffect(() => {
        if (donwloadURL) {
            const fetchPdf = async () => {
                try {
                    const data = await fileService.getPdfAsBase642(donwloadURL);
                    setUrlFile(data);
                } catch (error) {
                    console.error('Error loading PDF:', error);
                }
            };

            fetchPdf();
        }
    }, [donwloadURL]);

    useEffect(() => {
        return () => { setBean({}) }
    }, [])

    useEffect(() => {
        if (!initialInvoice) return;

        setBean(initialInvoice);
        setLista([{ DataBeanProperties: initialInvoice }]);
    }, [initialInvoice])

    useEffect(() => {
        if (file.Media || file.MediaContext) {
            setBean({ ...bean, "Media": file.Media, "MediaContext": file.MediaContext });
        }
    }, [file])

    useEffect(() => {
        setFileType(bean.MediaContext?.type || bean.Media?.split('.').pop())
        setDonwloadURL(fileService.getUrlFile(bean.MediaContext, bean.Media))
    }, [bean])

    const getProperties = (item: any) => item?.DataBeanProperties ?? item ?? {};

    const setInvoiceResponse = (invoice: any) => {
        setBean(invoice);
        setLista([{ DataBeanProperties: invoice }]);
    }

    const getDiscrepancyProperties = () => ({
        IDUBLDiscrepancyResponse: bean.IDUBLDiscrepancyResponse,
        UBLDiscrepancyResponseName: bean.UBLDiscrepancyResponseName,
        DiscrepancyResponseDescription: bean.DiscrepancyResponseDescription,
    });

    const updateCreatedInvoiceWithDiscrepancy = (resp: any, discrepancyProperties: any) => {
        const invoice = {
            ...resp,
            ...discrepancyProperties,
        };

        instance.updateUBLInvoice(invoice).then((updated: any) => {
            setInvoiceResponse(updated);
            modalForm.close();
            onSaved?.(updated);
        }).catch((err: any) => {
            toast.error(err);
        });
    }

    const createUBLInvoice = () => {
        const discrepancyProperties = getDiscrepancyProperties();

        if (entry === "Credit") {
            if (!bean.IDBusinessCore || !bean.IDProject) {
                toast.error("Debe seleccionar un Core de Negocio y un Proyecto");
            } else {
                instance.createUBLInvoiceForCreditNote(
                    bean.IDAccountCustomer,
                    bean.IDStore,
                    parseInt(bean.IDAccountantConcept),
                    bean.IssueDate,
                    bean.Media,
                    bean.MediaContext,
                    _single.getAccountID(),
                    obs,
                    bean.IDBusinessCore,
                    bean.IDProject,
                    bean.IDUBLInvoiceOwner,
                    bean.IssueDateOwner
                ).then(
                    (resp: any) => {
                        console.log(resp);
                        updateCreatedInvoiceWithDiscrepancy(resp, discrepancyProperties);
                    }
                ).catch(err => { toast.error(err) });
            }
        } else if (entry === "Debit") {
            if (!bean.IDBusinessCore || !bean.IDProject) {
                toast.error("Debe seleccionar un Core de Negocio y un Proyecto");
            } else {
                instance.createUBLInvoiceForDebtNote(
                    bean.IDAccountCustomer,
                    bean.IDStore,
                    parseInt(bean.IDAccountantConcept),
                    bean.IssueDate,
                    bean.Media,
                    bean.MediaContext,
                    _single.getAccountID(),
                    obs,
                    bean.IDBusinessCore,
                    bean.IDProject,
                    bean.IDUBLInvoiceOwner,
                    bean.IssueDateOwner
                ).then(
                    (resp: any) => {
                        console.log(resp);
                        updateCreatedInvoiceWithDiscrepancy(resp, discrepancyProperties);
                    }
                ).catch(err => { toast.error(err) });
            }
        }
    }

    const getUblInvoice = () => {
        instance.getUblInvoice(bean.IDUBLInvoice, bean.IssueDate)
            .then((resp) => {
                //console.log("Respuesta de la factura:", resp);
                const updatedList = lista.map((item) => {
                    if (item.DataBeanProperties.IDUBLInvoice === resp.IDUBLInvoice) {
                        return { DataBeanProperties: { ...item.DataBeanProperties, ...resp } };
                    }
                    return item;
                });

                setLista(updatedList);
            })
            .catch((err) => {
                //console.log("Error al obtener la factura:", err);
            });
    };

    const head = [
        { title: 'ID Factura', property: 'IDUBLInvoice', visible: true, mask: MASK_NUMBER },
        { title: 'Nit-Cliente', property: 'AccountCustomerName', visible: true },
        { title: 'Tipo UBL', property: 'UBLDocumentTypeName', visible: true },
        { title: 'Nit - Proveedor', property: 'AccountSupplierName', visible: true },
        { title: 'No Factura', property: 'InvoiceID', visible: true },
        { title: 'Líneas Factura', property: 'LineCountNumeric', visible: true },
        { title: 'Valor Total', property: 'TotalInvoiceAmount', visible: true, mask: MASK_MONEY },
        { title: 'Impuesto', property: 'TaxAmount', visible: true },
        { title: 'Descuentos', property: 'DiscountAmount', visible: true },
        { title: 'Aplicar Anticipo', property: 'ApplyPrepaidValue', visible: true, mask: MASK_BOOLEAN },
        { title: 'Valor del Anticipo', property: 'PrepaidPayment', visible: true, mask: MASK_MONEY },
        { title: 'Fecha Factura', property: 'IssueDate', visible: true, mask: MASK_DATE },
        { title: 'Documento Factura', property: 'Doc', visible: true },
        { title: 'Entrada de Almacén/Remisión', property: 'Remision', visible: true },
        { title: 'Estado Factura', property: 'DocumentStateName', visible: true },
        { title: 'Tipo Factura', property: 'SourceTypeName', visible: true },
        { title: 'Estado EAF', property: 'EAFDocumentStateName', visible: true },
        { title: 'Documento Soporte', property: 'IsDocumentSupport', visible: true, mask: MASK_BOOLEAN },
        { title: 'Concepto de Ingreso', property: 'AccountantConceptName', visible: true },
        { title: 'Cuenta Contable', property: 'AccountantIDName', visible: true },
        { title: 'Cuenta Puente Ingreso Bienes', property: 'CreditAccountantIDName', visible: true },
        { title: 'Pertenece a Proceso', property: 'ProcessTypeName', visible: true },
        { title: 'Discrepancia', property: 'UBLDiscrepancyResponseName', visible: true },
        { title: 'Descripcion Discrepancia', property: 'DiscrepancyResponseDescription', visible: true },
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-line', visible: true, evento: () => { openEditModal(bean) } },
            { titulo: 'ver Items de la Factura', icono: 'ri-list-ordered', visible: true, evento: () => { setModalB({ ...modalB, "view": true, "name": `Items de la Factura ${bean.IDUblInvoice}` }) } },
            { titulo: 'Actualizar Consumidor', icono: 'ri-person-line', visible: (bean.SourceType === 7 || modifiAnyWay), evento: () => { setModalCustomer({ ...modalCustomer, "view": true, "name": "Actualizar Consumidor" }) } },
            { titulo: 'Anular', icono: 'ri-forbid-line', visible: true, evento: () => { setModalConfirm({ ...ModalConfirm, "view": true, "name": "Anular Factura" }); setObs("") } },
            { titulo: 'Abrir Factura', icono: 'ri-file-list-line', visible: true, evento: () => { setModal({ ...modal, "name": "Abrir archivo", "view": true, "format": `${fileType !== "pdf" && "jpg" && "png" ? "modal-sm" : "modal-xl"}` }) } },
            { titulo: 'Ver eventos en la Factura', icono: 'ri-history-line', visible: true, evento: () => { setModalC({ ...modalC, "view": true, "name": "Ver eventos en la Factura" }) } },
            { titulo: 'Ver Documentos Contables', icono: 'ri-list-ordered', visible: true, evento: () => { setModalSeeDoc({ ...modalSeeDoc, "view": true, "name": `Ver Documentos Contables` }) } },
        ]

        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const [ModalConfirm, setModalConfirm] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });

    const nullUBL = () => {
        instance.nullifyUBLInvoice(bean.IDUBLInvoice, bean.IssueDate, _single.getAccountID(), obs).then(
            (resp) => {
                setBean({})
                setLista([]);
                setObs("");
                if (resp.length > 0) {
                    resp.map((e) => {
                        setModalConfirm({ ...ModalConfirm, "view": false });
                        toast.info(e, { autoClose: false });
                    });
                } else {
                    toast.error("No se ha podido anular la factura.")
                }
            }
        ).catch(
            err => {
                console.log(err);
            }
        )
    }

    const setRowBean = (bean: any) => {
        if (_onChange2) {
            _onChange2(bean)
        }
        setBean(bean)
    }

    const openCreateModal = () => {
        setBean({});
        setFile({});
        setObs(" ");
        setMissingFields([]);
        modalForm.open(`Crear ${noteLabel}`);
    }

    const openEditModal = (row: any) => {
        setRowBean(row);
        setMissingFields([]);
        modalForm.open(`Editar ${noteLabel}`);
    }

    const createAccountantDocumentForUBLInvoice = () => {
        instance.createAccountantDocumentForUBLInvoice(bean.IDUBLInvoice, bean.IssueDate, recordDate, _single.getAccountID())
            .then(
                (resp: any) => {
                    //console.log(resp);
                    if (resp.MsgList) {
                        setDocumentError(resp.MsgList);
                    }
                    if (resp.DocumentURL) {
                        let docs: DocumentPDF[] = [];
                        resp.DocumentURL.forEach(element => {
                            docs.push({
                                Filename: element.DataBeanProperties.Filename,
                                Media: element.DataBeanProperties.Media,
                                MediaContext: element.DataBeanProperties.MediaContext,
                                Type: element.DataBeanProperties.Type,
                                URLLink: element.DataBeanProperties.URLLink
                            })
                        });
                        setDocument(docs);
                    }
                    setModalVisor({ ...modalVisor, "view": true });
                    setModalAccounting({ ...modalAccounting, "view": false });
                }
            ).catch(err => toast.error(err));
    }

    const [missingFields, setMissingFields] = useState<string[]>([]);

    const validateData = () => {
        if (validateForm() > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            if (bean.IDUBLInvoice) {
                updateInvoice();
            } else {
                createUBLInvoice();
            }
        }
    }

    const updateInvoice = () => {
        if (bean.ApplyPrepaidValue) {
            if (!bean.PrepaidIDAccountantStr || bean.PrepaidIDAccountantStr.trim() === "") {
                toast.error("Debe seleccionar la cuenta contable del anticipo.");
                return;
            }
            if (!bean.PrepaidPayment || isNaN(bean.PrepaidPayment) || bean.PrepaidPayment <= 0) {
                toast.error("Debe ingresar un valor válido del anticipo.");
                return;
            }
        }
        instance.updateUBLInvoice(bean).then(
            (resp) => {
                setBean(resp);
                let temp = [];
                temp.push({
                    DataBeanProperties: resp
                });

                setLista(temp);
                modalForm.close();
                setModalCustomer({ ...modalCustomer, "view": false });
                setModalApplyPrepaid({ ...modalApplyPrepaid, "view": false });
                onSaved?.(resp);
            }
        ).catch(
            err => { console.log(err) }
        )
    }

    const validateForm = () => {
        let requiredFields = [
            "IDStore",
            "IDAccountantConcept",
            "IssueDate",
            "IDBusinessCore",
            "IDProject",
            "IDAccountCustomer",
            "IDUBLDiscrepancyResponse",
            "DiscrepancyResponseDescription",
        ];

        let missing = [];
        for (let field of requiredFields) {
            const value = bean[field];
            if (value === null || value === undefined || value === "" || (typeof value === "string" && value.trim() === "")) {
                missing.push(field);
            }
        }

        //console.log(missing)
        setMissingFields(missing);
        return missing.length
    };

    const applyPreapid = () => {
        if (bean.ApplyPrepaidValue) {
            if (!bean.PrepaidIDAccountantStr || bean.PrepaidIDAccountantStr.trim() === "") {
                toast.error("Debe seleccionar la cuenta contable del anticipo.");
                return;
            }
            if (!bean.PrepaidPayment || isNaN(bean.PrepaidPayment) || bean.PrepaidPayment <= 0) {
                toast.error("Debe ingresar un valor válido del anticipo.");
                return;
            }
        }
        instance.applyPrepaidPayment(bean.IDUBLInvoice, bean.IssueDate, bean.ApplyPrepaidValue, bean.ApplyPrepaidValue ? bean.PrepaidIDAccountantStr : null, bean.ApplyPrepaidValue ? bean.PrepaidPayment : null).then(
            (resp) => {
                setBean(resp);
                let temp = [];
                temp.push({
                    DataBeanProperties: resp
                });

                setLista(temp);
                setModalPrepaid({ ...modalPrepaid, "view": false });
            }
        ).catch(err => (console.log(err)))
    }

    const renderForm = () => (
        <div className="row">
            <div className="col-md-6">
                <label className={`${missingFields.includes('IDAccountantConcept') ? 'has-error' : ''}`}>Concepto de Ingreso de Facturación de Venta</label>
                <SelectAccountantConceptCatalogForSalesInvoice label=" " idSelector={bean.IDAccountantConcept} onChange={(e) => { setBean({ ...bean, "IDAccountantConcept": e }) }} />
            </div>

            <div className="col-md-6">
                <label className={`${missingFields.includes('IDStore') ? 'has-error' : ''}`}>Almacen</label>
                <SelectStoreEditor idSelector={bean.IDStore} onChange={(e) => { setBean({ ...bean, "IDStore": e.IDStore }) }} label=" " />
            </div>
            <div className="col-md-6">
                <label className={`${missingFields.includes('IDProject') ? 'has-error' : ''}`}>Proyecto</label>
                <SelectProject
                    label=" "
                    idSelector={bean.IDProject}
                    onChange={(value) => {
                        if (!value) {
                            setBean({
                                ...bean,
                                IDProject: null,
                                IDAccount: null,
                                IDBusinessCore: null
                            });
                            return;
                        }

                        const { IDProject, IDAccount, IDBusinessCore } = value;
                        setBean({
                            ...bean,
                            IDProject: IDProject ?? null,
                            IDAccount: IDAccount ?? null,
                            IDBusinessCore: IDBusinessCore ?? null
                        });
                    }}
                    returnType="Object"
                />

            </div>
            <div className="col-md-6">
                <label className={`${missingFields.includes('IDBusinessCore') ? 'has-error' : ''}`}>Core de Negocio</label>
                <SelectBusinessCore label=" " idSelector={bean.IDBusinessCore} onChange={(e) => { setBean({ ...bean, "IDBusinessCore": e }) }} />
            </div>

            <div className="col-md-6">
                <label className={`${missingFields.includes('IDAccountCustomer') ? 'has-error' : ''}`}>Consumidor</label>
                <AccountEditor idAccount={bean.IDAccountCustomer} label=" " onChange={(e) => { setBean({ ...bean, "IDAccountCustomer": e.IDAccount }); }} />
            </div>

            <div className="col-md-6">
                <FileInput Media={bean.Media} MediaContext={bean.MediaContext} label={`Archivo Remisión`} directory="temp" onCreate={(e) => { setFile(e) }} />
            </div>

            <div className="col-md-6">
                <label className={`${missingFields.includes('IssueDate') ? 'has-error' : ''}`}>Fecha de Factura</label>
                <InputDate notDate label=" " name="IssueDate" value={bean.IssueDate} setDate={(e) => { setBean({ ...bean, "IssueDate": e }) }} />
            </div>

            <div className="col-md-6">
                <UBLDocumentCatalogEditor label="Factura de Venta" typeUBL={1} onChange={(e) => { setBean({ ...bean, "IDUBLInvoiceOwner": e.IDUBLInvoice, "IssueDateOwner": e.IssueDate }) }} />
            </div>

            <div className="col-md-6">
                <label className={`${missingFields.includes('IDUBLDiscrepancyResponse') ? 'has-error' : ''}`}>Discrepancia</label>
                <EditorUBLDiscrepancyResponse
                    label=" "
                    idSelector={bean.IDUBLDiscrepancyResponse}
                    onChange={(e) => {
                        const data = getProperties(e);
                        setBean({
                            ...bean,
                            IDUBLDiscrepancyResponse: data.IDUBLDiscrepancyResponse,
                            UBLDiscrepancyResponseName: data.Name ?? data.UBLDiscrepancyResponseName,
                        });
                    }}
                />
            </div>

            <div className="col-md-6">
                <label className={`${missingFields.includes('DiscrepancyResponseDescription') ? 'has-error' : ''}`}>Descripcion Discrepancia</label>
                <textarea
                    className="form-control"
                    value={bean.DiscrepancyResponseDescription ?? ""}
                    onChange={(e) => { setBean({ ...bean, DiscrepancyResponseDescription: e.target.value }) }}
                />
            </div>

            <div className="col-md-12">
                <label>Observaciones</label>
                <textarea name="obs" className="form-control" value={obs} onChange={(e) => { setObs(e.target.value) }} ></textarea>
            </div>
        </div>
    )

    if (embedded) {
        return (
            <>
                {renderForm()}
                <div className="row">
                    <div className="col-md-6 mt-4">
                        <BasicButton icon="ri-save-2-line" eventClick={validateData}>
                            {bean.IDUBLInvoice ? "Actualizar" : "Crear"}
                        </BasicButton>
                    </div>
                </div>
            </>
        )
    }

    return (
        <>
            <div className="row mb-3">
                <div className="col-md-4">
                    <BasicButton icon="ri-file-add-line" eventClick={openCreateModal}>{`Crear ${noteLabel}`}</BasicButton>
                </div>
            </div>

            <Modal
                modal={modalForm.modal}
                updateModal={modalForm.setModal}
                eventModal={validateData}
                onSubmitLabel={bean.IDUBLInvoice ? "Actualizar" : "Crear"}
            >
                {renderForm()}
            </Modal>

            <div className="row">
                {/* <PrintJson json={bean} /> */}
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={(e) => { setRowBean(e) }} listButtons={listaBotones()} />
                </div>
                {(bean.IDUBLInvoice) &&
                    <div className="row d-flex justify-content-between mt-4">
                        <div className="col-md-6">
                            <BasicButton eventClick={() => { setModalFire({ ...modalFire, "view": true, "name": `Transmitir/Descargar Documento` }) }} icon="ri-save-line" children={"Transmitir Documento Electrónico"} />
                        </div>
                        <div className="col-md-6 d-flex justify-content-end">
                            <BasicButton eventClick={() => { setModalAccounting({ ...modalAccounting, "view": true, "name": `Contabilizar ${entry === "Credit" ? "Nota Credito" : "Nota Debito"}` }) }} icon="ri-save-line" children={`Contabilizar ${entry === "Credit" ? "Nota Credito" : "Nota Debito"}`} />
                        </div>
                    </div>
                }
            </div>

            <Modal modal={modalB} updateModal={setModalB} >
                <CreateUBLInvoiceItems idUBLInvoice={bean.IDUBLInvoice} issueDate={bean.IssueDate} _onChange={() => { getUblInvoice(); }} />
            </Modal>

            <Modal modal={modal} updateModal={setModal} eventModal={() => { }} >
                <div className="row">
                    <div className="col-md-12">
                        <div className="iframe-container">

                            {fileType ?
                                <>
                                    <PrintJson json={fileType} />
                                    {fileType === 'pdf' && (
                                        urlFile ? (
                                            <iframe name="pdfviwer" src={urlFile} onError={(e) => console.error('Error loading PDF:', e)}></iframe>
                                        ) : (
                                            <p>Cargando PDF...</p>
                                        )
                                    )}
                                    {fileType === `"jpg"` || fileType === "png" &&
                                        (
                                            <img src={urlFile} alt="Image Preview" width="100%" />
                                        )
                                    }
                                    {fileType !== "pdf" && "jpg" && "png" &&
                                        <>
                                            <a href={donwloadURL} target='_blank'>Clic aquí para descargar el archivo {bean.Media}</a>
                                        </>
                                    }
                                </>
                                :
                                <>
                                    No se pudo cargar el Documento
                                </>
                            }
                        </div>
                    </div>
                </div>
            </Modal>

            <Modal modal={modalC} updateModal={setModalC} >
                <HistoryUBLInvoice _idUBLInvoice={bean.IDUBLInvoice} _isseDate={bean.IssueDate} />
            </Modal>

            <Modal modal={modalFire} updateModal={setModalFire} >
                <FireElectronicDocument _idUBLInvoice={bean.IDUBLInvoice} _isseDate={bean.IssueDate} />
            </Modal>

            <Modal modal={modalSeeDoc} updateModal={setModalSeeDoc} >
                <AccountantDocumentList _idUBLInvoice={bean.IDUBLInvoice} _isseDate={bean.IssueDate} />
            </Modal>

            <Modal modal={modalCustomer} updateModal={setModalCustomer} eventModal={updateInvoice}  >
                <div className="row">
                    <div className="col-md-12">
                        <AccountEditor idAccount={bean.IDAccountCustomer} label="Consumidor" onChange={(e) => { setBean({ ...bean, "IDAccountCustomer": e.IDAccount }); }} />
                    </div>
                </div>
            </Modal>

            <Modal modal={modalPrepaid} updateModal={setModalPrepaid} eventModal={() => { applyPreapid() }}  >
                <div className="row">
                    <div className="col-md-12">
                        <BasicSwitch label="Aplicar Anticipo" estado={bean.ApplyPrepaidValue} eventChange={(e) => { setBean({ ...bean, "ApplyPrepaidValue": e }) }} />
                    </div>
                    <div className="col-md-12">
                        <PrepaidPaymentEditor _Invoice={bean} onChange={(e) => { setBean({ ...bean, "PrepaidIDAccountantStr": e.JsonCode }) }} />
                    </div>
                    <div className="col-md-12">
                        <InputMoney _value={bean.PrepaidPayment} onChange={(e) => { setBean({ ...bean, "PrepaidPayment": e }) }} _label="Valor del Anticipo a Cruzar" />
                    </div>
                </div>
            </Modal>

            <Modal modal={modalApplyPrepaid} updateModal={setModalApplyPrepaid} eventModal={() => { updateInvoice() }}  >
                <div className="row">
                    <div className="col-md-12">
                        <BasicSwitch label="Aplicar Anticipo" estado={bean.ApplyPrepaidValue} eventChange={(e) => { setBean({ ...bean, "ApplyPrepaidValue": e }) }} />
                    </div>
                    <div className="col-md-12">
                        <ReciablePaymentEditor renderValue={bean.PrepaidIDAccountantStr} _Invoice={bean} onChange={(e) => { setBean({ ...bean, "PrepaidIDAccountantStr": e.JsonCode }) }} />
                    </div>
                    <div className="col-md-12">
                        <InputMoney _value={bean.PrepaidPayment} onChange={(e) => { setBean({ ...bean, "PrepaidPayment": e }) }} _label="Valor del Anticipo a Cruzar" />
                    </div>
                </div>
            </Modal>

            <Modal modal={modalAccounting} updateModal={setModalAccounting} eventModal={createAccountantDocumentForUBLInvoice} onSubmitLabel="Procesar">
                {/* contabilizar la factura electronica */}
                <div className="row">
                    <div className="col-md-12">
                        <InputDate label="Fecha de registro contable" name="date" value={recordDate} setDate={setRecordDate} />
                    </div>
                </div>
            </Modal>

            <Modal modal={modalVisor} updateModal={setModalVisor} >
                {/* visor de documentos */}
                <div className="row">
                    <div className="col-md-12">
                        {documentError.length > 0 ?
                            // <PrintJson json={documentError} />
                            <ul className="group-list">
                                {documentError.map((item: any, index: number) => {
                                    return (
                                        <li key={index} className="group-list-item">{item}</li>
                                    )
                                })}
                            </ul>
                            :
                            <>
                                {document.length > 0 &&
                                    <DocumentViewer list={document} />
                                }
                            </>
                        }
                    </div>
                </div>
            </Modal>

            <Modal modal={ModalConfirm} updateModal={setModalConfirm} eventModal={() => { nullUBL() }}  >
                <div className="row">
                    <div className="col-md-6">
                        <strong>ID Factura </strong><small>{bean.IDUBLInvoice}</small>
                    </div>
                    <div className="col-md-6">
                        <strong>Fecha Factura </strong><small>{bean.IssueDate}</small>
                    </div>
                    <div className="col-md-12">
                        <label >Justificación</label>
                        <textarea className="form-control" value={obs} onChange={(e) => { setObs(e.target.value) }} />
                    </div>
                </div>
            </Modal>
        </>
    )
}
